// Drive half of a boat-accel stroke: catch (lowest point, stroke start) →
// finish dip (first low after accel falls back below zero past the drive peak).
const MIN_PEAK = 0.2;   // m/s² — drive peak must clear noise
const RISE = 0.08;      // m/s² — rise off the finish dip that confirms it

// pts: [{dt, a}] from the catch. Returns end index, or -1 while still in the drive (live).
export function driveEndIndex(pts, final = false) {
  let peak = -Infinity;
  let minI = -1;
  for (let i = 0; i < pts.length; i += 1) {
    const { a } = pts[i];
    if (minI < 0) {
      if (a > peak) peak = a;
      if (peak >= MIN_PEAK && a < 0) minI = i;
    } else if (a < pts[minI].a) minI = i;
    else if (a > pts[minI].a + RISE) return minI;
  }
  if (!final) return -1;
  return minI >= 0 ? minI : Math.max(1, Math.floor(pts.length / 2));
}

export function trimDrive(pts, final = false) {
  const i = driveEndIndex(pts, final);
  return i < 0 ? pts : pts.slice(0, i + 1);
}

// Same for compact [[dt, a], ...] arrays (pinned ideals, snapshots).
export function trimDrivePairs(points) {
  if (!points?.length) return points;
  const i = driveEndIndex(points.map(([dt, a]) => ({ dt, a })), true);
  return points.slice(0, i + 1);
}
